import PropTypes from "prop-types"
import React, { useState, useEffect, useMemo } from "react"
import moment from "moment-timezone"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  FormFeedback,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap"
import Switch from "react-switch"
import "react-datepicker/dist/react-datepicker.css"
import { seasonPasstSatusTypes, roleType, messageTitle } from "constants/common"
import { convertUtcToLocal, convertDateToUtc } from "../../helpers/util"
// actions
import { addNewRole, updateRole, clearMessage } from "../../store/roles/actions"

//redux
import { useSelector, useDispatch } from "react-redux"
import { dateformat, timezone } from "config"
// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"
import { isEmpty } from "lodash"
import toastr from "toastr"
import "toastr/build/toastr.min.css"

import OffSymbol from "components/Common/OffSymbol"
import OnSymbol from "components/Common/OnSymobl"
let todayDate = moment()
let defaultExpiry = moment().add(1, "days")

const getScheduleDate = item => {
  if (item) {
    const schedule = item?.scheduled || null
    if (schedule) {
      return !Array.isArray(schedule)
        ? schedule.dateScheduled
        : schedule.length > 0
        ? schedule[0].dateScheduled
        : todayDate
    }
  }
  return todayDate
}

const RoleCreate = props => {
  const dispatch = useDispatch()
  const { role, setSelectedRole, toggle, isOpen } = props
  // Form validation
  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      roleTitle: role?.roleTitle || "",
      scheduleDate: convertUtcToLocal(getScheduleDate(role)),
      expireDate: convertUtcToLocal(role?.expireDate || defaultExpiry),
      scheduleChangeDate: defaultExpiry,
    },
    validationSchema: Yup.object({
      roleTitle: Yup.string().required("Please enter role title"),
      expireDate: Yup.string().required("Please select schedule date"),
    }),
    onSubmit: values => {
      const _status = !liveStatus
        ? seasonPasstSatusTypes["Not-Available"]
        : liveStatus &&
          convertUtcToLocal(todayDate, "YYYY-MM-DD") ==
            convertUtcToLocal(values["scheduleDate"], "YYYY-MM-DD")
        ? seasonPasstSatusTypes.Available
        : seasonPasstSatusTypes.Pending
      let roleObj = {
        roleTitle: values["roleTitle"],
        roleType: type ? roleType.CMS_ONLY : roleType.PUBLIC,
        status: _status,
        expireDate: expiryStatus
          ? convertDateToUtc(values["expireDate"])
          : null,
        scheduled: [],
      }
      if (_status == "Pending" && isEmpty(role)) {
        roleObj = {
          ...roleObj,
          scheduled: [
            {
              dateScheduled: convertDateToUtc(values["scheduleDate"]),
              updateField: "status",
              updateData: "Available",
            },
          ],
        }
      } else if (_status == "Pending" && !isEmpty(role)) {
        let _scheduleObj = []
        if (role?.roleTitle != roleObj?.roleTitle) {
          _scheduleObj.push({
            dateScheduled: convertDateToUtc(values["scheduleDate"]),
            updateField: "roleTitle",
            updateData: roleObj?.roleTitle,
          })
          delete roleObj?.roleTitle
        }
        if (role?.roleType != roleObj?.roleType) {
          _scheduleObj.push({
            dateScheduled: convertDateToUtc(values["scheduleDate"]),
            updateField: "roleType",
            updateData: roleObj?.roleType,
          })
          delete roleObj?.roleType
        }
        roleObj = {
          ...roleObj,
          scheduled: _scheduleObj,
        }
      }
      if (!isEmpty(role)) {
        roleObj = { ...roleObj, id: role._id }
        dispatch(updateRole(roleObj))
      } else {
        dispatch(addNewRole(roleObj))
      }
      setSelectedRole({})
      setType(false)
      setLiveStatus(false)
      setExpiryStatus(false)
    },
  })
  const [scheduleChange, setScheduleChange] = useState(false)
  const [type, setType] = useState(false)
  const [liveStatus, setLiveStatus] = useState(true)
  const [expiryStatus, setExpiryStatus] = useState(false)

  useEffect(() => {
    if (role && !isEmpty(role)) {
      validation.initialValues = {
        roleTitle: role?.roleTitle || "",
        scheduleDate: convertUtcToLocal(getScheduleDate(role)),
        expireDate: convertUtcToLocal(role?.expireDate || defaultExpiry),
      }
      setType(role?.roleType == "CMS_ONLY")
      //setLiveStatus(!isEmpty(role?.scheduled))
      setLiveStatus(true)
      setExpiryStatus(!isEmpty(role?.expireDate))
    }
  }, [role])

  const { error, message } = useSelector(state => ({
    error: state.roles.error,
    message: state.roles.message,
  }))

  useMemo(() => {
    if (message) {
      toastr.success(message, messageTitle)
      toggle()
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, message])

  useMemo(() => {
    if (!isEmpty(error)) {
      toastr.error(
        error?.message || "Oops..Something went wrong.",
        messageTitle
      )
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, error])
  const _scheduleChangeDate = validation.values.scheduleChangeDate
    ? moment(validation.values.scheduleChangeDate).format(dateformat.default)
    : ""

  return (
    <Modal isOpen={isOpen} toggle={toggle} className={"modal-lg"}>
      <ModalHeader toggle={toggle} tag="h4">
        {role ? "Update Role" : "Add New Role"}
      </ModalHeader>
      <ModalBody>
        <React.Fragment>
          <Col lg="24" xl="24">
            <Form
              className="form-row"
              onSubmit={e => {
                e.preventDefault()
                validation.handleSubmit()
                return false
              }}
            >
              {/* <FormGroup row>
                <Col md="6">
                  <Label className="col-form-label col-lg-2">Live</Label>
                  <Row>
                    <Col md={2} className="pr-0 pt-1">
                      <Switch
                        checked={liveStatus}
                        onColor="#626ed4"
                        onChange={() => setLiveStatus(!liveStatus)}
                        uncheckedIcon={<OffSymbol text="Off" />}
                        checkedIcon={<OnSymbol text="On" />}
                      />
                    </Col>
                    {liveStatus && (
                      <Col md={10} className="pl-0">
                        <input
                          className="form-control"
                          type="date"
                          defaultValue={validation.values.scheduleDate}
                          id="scheduleDate"
                          name="scheduleDate"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.scheduleDate &&
                            validation.errors.scheduleDate
                              ? true
                              : false
                          }
                        />
                        {validation.touched.scheduleDate &&
                        validation.errors.scheduleDate ? (
                          <FormFeedback type="invalid">
                            {validation.errors.scheduleDate}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    )}
                  </Row>
                </Col>
                <Col md="6">
                  <Label className="col-form-label col-md-6">Expire Date</Label>
                  <Row>
                    <Col md={2} className="pr-0 pt-1">
                      <Switch
                        checked={expiryStatus}
                        onColor="#626ed4"
                        onChange={() => setExpiryStatus(!expiryStatus)}
                        uncheckedIcon={<OffSymbol text="Off" />}
                        checkedIcon={<OnSymbol text="On" />}
                      />
                    </Col>
                    {expiryStatus && (
                      <Col md={10} className="pr-0">
                        <input
                          className="form-control"
                          type="date"
                          defaultValue={validation.values.expireDate}
                          id="expireDate"
                          name="expireDate"
                          onChange={validation.handleChange}
                          invalid={
                            validation.touched.expireDate &&
                            validation.errors.expireDate
                              ? true
                              : false
                          }
                        />
                        {validation.touched.expireDate &&
                        validation.errors.expireDate ? (
                          <FormFeedback type="invalid">
                            {validation.errors.expireDate}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    )}
                  </Row>
                </Col>
              </FormGroup> */}
              {/* <FormGroup row>
                <Col md={12}>
                  {setSelectedRole && (
                    <div>
                      <Label className="form-label">Schedule Change</Label>
                      <Row className="mb-2">
                        <Col md={2} className="pr-0 pt-1">
                          <Switch
                            checked={scheduleChange}
                            onColor="#626ed4"
                            onChange={() => setScheduleChange(!scheduleChange)}
                            uncheckedIcon={<OffSymbol text="Off" />}
                            checkedIcon={<OnSymbol text="On" />}
                          />
                        </Col>
                        {scheduleChange && (
                          <Col md={10} className="pl-0">
                            <input
                              className="form-control"
                              type="date"
                              defaultValue={_scheduleChangeDate}
                              id="scheduleChangeDate"
                              name="scheduleChangeDate"
                              min={moment().format("YYYY-MM-DD")}
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              invalid={
                                validation.touched.scheduleChangeDate &&
                                validation.errors.scheduleChangeDate
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.scheduleChangeDate &&
                            validation.errors.scheduleChangeDate ? (
                              <FormFeedback type="invalid">
                                {validation.errors.scheduleChangeDate}
                              </FormFeedback>
                            ) : null}
                          </Col>
                        )}
                      </Row>
                    </div>
                  )}
                </Col>
              </FormGroup> */}
              <FormGroup row>
                <Col md={8}>
                  <Label
                    htmlFor="roletitle"
                    className="col-form-label col-md-8"
                  >
                    Role Title*
                  </Label>
                  <Input
                    id="roleTitle"
                    name="roleTitle"
                    type="text"
                    className="form-control"
                    placeholder="Enter role title..."
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.roleTitle || ""}
                    invalid={
                      validation.touched.roleTitle &&
                      validation.errors.roleTitle
                        ? true
                        : false
                    }
                  />
                  {validation.touched.roleTitle &&
                  validation.errors.roleTitle ? (
                    <FormFeedback type="invalid">
                      {validation.errors.roleTitle}
                    </FormFeedback>
                  ) : null}
                </Col>
                <Col md={4}>
                  <Label
                    htmlFor="projectname"
                    className="col-form-label col-md-4"
                  >
                    CMS Only
                  </Label>
                  <Col md={2} className="pt-1">
                    <Switch
                      checked={type}
                      onColor="#626ed4"
                      onChange={() => setType(!type)}
                      uncheckedIcon={<OnSymbol text="No" />}
                      checkedIcon={<OffSymbol text="Yes" />}
                    />
                  </Col>
                </Col>
              </FormGroup>

              <Row className="justify-content-end">
                <Col xl="12" className="text-end">
                  <Button type="submit" color="primary">
                    {isEmpty(role) ? "Add New Role" : "Update Role"}
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </React.Fragment>
      </ModalBody>
    </Modal>
  )
}

export default RoleCreate
RoleCreate.propTypes = {
  history: PropTypes.object,
  role: PropTypes.object,
  setSelectedRole: PropTypes.func,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
}
